import { Grid } from '@mui/material';
import React from 'react';
import { Textfield } from '.';
import { displayError, isValidContact } from '../helpers';
import { AddressForm } from './AddressForm';

export function UserContactInfo(props) {
    const { name, userContactDetails, handleInfoChange, validationErrors } = props;
    return <Grid container rowGap={3} columnSpacing={'12px'}>
        <Grid item xs={12} lg={6} md={6}>
            <Textfield
                id="firstName"
                name={name}
                label="First Name *"
                autoComplete="given-name"
                value={userContactDetails.firstName}
                onChange={handleInfoChange}
                error={displayError(validationErrors?.firstName)}
                helperText={validationErrors?.firstName}
                fullWidth
            />
        </Grid>

        <Grid item xs={12} lg={6} md={6}>
            <Textfield
                id="lastName"
                name={name}
                label="Last Name *"
                autoComplete="family-name"
                value={userContactDetails.lastName}
                onChange={handleInfoChange}
                error={displayError(validationErrors?.lastName)}
                helperText={validationErrors?.lastName}
                fullWidth
            />
        </Grid>
        <Grid item xs={12} lg={6} md={6}>
            <Textfield
                id="email"
                name={name}
                label="Email *"
                autoComplete="email"
                value={userContactDetails.email}
                onChange={handleInfoChange}
                error={displayError(validationErrors?.email)}
                helperText={validationErrors?.email}
                disabled={!props.allowEmailUpdation}
                fullWidth
            />
        </Grid>

        <Grid item xs={12} lg={6} md={6}>
            <Textfield
                id="contactNumber"
                name={name}
                label="Contact Number *"
                type="text"
                autoComplete="tel"
                onChange={handleInfoChange}
                value={userContactDetails.contactNumber}
                error={displayError(validationErrors?.contactNumber)}
                helperText={validationErrors?.contactNumber}
                fullWidth
            />
        </Grid>

        <Grid item xs={12}>
            <AddressForm name={name} addressDetails={userContactDetails} updateAddressDetails={handleInfoChange} validationErrors={validationErrors} />
        </Grid>
    </Grid>
}
